export default class Appointments {
    id: number;
    title: string;
    start: Date;
    end: Date;
    reason: string;
    notes: string;
    reminderTime: number;
    patientId: number;
    patientName: string;

    constructor(id: number, title: string, start: Date, end: Date, reason: string, notes: string, reminderTime: number, patientId: number, patientName: string) {
        this.id = id;
        this.title = title;
        this.start = new Date(start);
        this.end = new Date(end);
        this.reason = reason;
        this.notes = notes;
        this.reminderTime = reminderTime
        this.patientId = patientId;
        this.patientName = patientName;

    }
}